import { Stack, Typography, useTheme } from '@mui/material'
import React, { FC } from 'react'
import { Table } from '../../../../../../components/table'

interface GrantsTableProps {
  grants: any[]
  tableHeader: string[]
}

export const PFGrantsTable: FC<GrantsTableProps> = ({ grants, tableHeader }) => {
  const theme = useTheme()

  const headerCells = tableHeader.map((header, index) => {
    return {
      content: (
        <Typography key={index} color="secondary" fontWeight={500} fontSize="0.9rem">
          {header}
        </Typography>
      ),
    }
  })

  const rows: any[] =
    grants &&
    grants.map((rowCell: any) => {
      const cells = [
        {
          content: (
            <Typography
              color="secondary"
              fontSize="0.875rem"
              fontWeight={theme.typography.fontWeightMedium}
            >
              {rowCell.title}
            </Typography>
          ),
          cellProps: {
            sx: { maxWidth: 300 },
          },
        },
        {
          content: (
            <Typography
              fontSize="0.875rem"
              color="secondary.light"
              fontWeight={theme.typography.fontWeightMedium}
            >
              ${rowCell.formattedAmount}
            </Typography>
          ),
          cellProps: {
            sx: { display: { xs: 'none', sm: 'table-cell' } },
          },
        },

        {
          content: (
            <Typography
              fontSize="0.875rem"
              color="secondary.light"
              fontWeight={theme.typography.fontWeightMedium}
            >
              {rowCell.dueDate}
            </Typography>
          ),
          cellProps: {
            sx: { display: { xs: 'none', sm: 'table-cell' } },
          },
        },
      ].filter(Boolean)

      return {
        rowProps: {
          sx: { '&:hover': { cursor: 'pointer', background: theme.palette.grey[100] } },
        },
        cells,
      }
    })

  return (

    <Stack
      sx={{
        my: '1rem',
        borderRadius: '8px',
        background: 'white',
        boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.06)'
      }}
      justifyContent="space-between"
    >
      <Table
        containerProps={{
          sx: {
            boxShadow: 'none',
            background: 'transparent',
          },
        }}
        head={{
          containerProps: {
            sx: { borderRadius: '8px', background: theme.palette.grey[200], width: '100%' },
          },
          rows: [{ cells: headerCells || [] }],
        }}
        body={{ rows }}
      />
    </Stack>
  )
}
